export const sliderData = [
  {
    background: 'mobile',
    content: 'Here you can work with future industries!',
    description:
      'The digitizing world is what triggers us to bring technology into thriving industries. We create apps for sharing economy businesses, renewable energy, fintech, automotive, you name it. And there’s even more to come as we grow!',
    link: '',
  },
  {
    background: 'mac',
    content: 'Create impactful, scalable products',
    description:
      'If you are excited about building high quality products that help people make their lives easier, this is your new place to work. Say “hi” to the team of savvy developers and designers who share the skill and mindset to make it happen.',
    link: '',
  },
  {
    background: 'apps',
    content: 'Do you like running sprints?',
    description:
      'Implementing MVPs in only 4 weeks is quite a challenge. But for us it’s a wonderful opportunity to learn how to work it out! Being a fast-learner willing to experiment is the key here. Discover what’s it all about in Virgin Radio case study.',
    link: '',
  },
  {
    background: 'space',
    content: 'It’s nice to be awarded!',
    description:
      'The code engraved in our hearts and the human-centred design running through our veins help us win international awards like Awwwards or Indigo Awards. There’s a chance for you to become a part of the winning team.',
    link: '',
  },
];
